import { Modal, Button } from "react-bootstrap";
import React,{ useState } from "react";
import { api_url } from "../../constant/constant";
import { useTranslation } from 'react-i18next';
import { showToast } from "../ShowToast/ToastNotification";

const Sync = ({ id, parentfetchLDAPServer }) => {
    const ldap_id = id;
    const [show, setShow] = useState(false); // Correct syntax for declaring state
    const [syncing, setSyncing] = useState(false); // To track sync progress
    const [error, setError] = useState(null); // To store error message
    const { t } = useTranslation();
    
    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => setShow(true);

    const handleSync = async () => {
        setSyncing(true); // Start syncing
        const token = localStorage.getItem("userToken");
        try {
            const response = await fetch(`${api_url}/sync`, {
                method: 'POST', // Assuming it's a POST request
                headers: {
                    'Authorization': `Bearer ${token}`, // Replace with actual token
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ server_id: ldap_id }), // Pass the server_id for sync initiation
            });
    
            if (!response.ok) {
                const result = await response.json();
                showToast(t("failedtoinitiatesync", { message: result?.message }), "error");
                handleClose();
            }
            
            const result = await response.json();
            if (result.message) {
                showToast(t("syncsuccessful", { message: result?.message }), "success");
                handleClose();
            }            
        } catch (error) {
            // showToast(error.message || "An error occurred while initiating sync.", "error");
            handleClose();
        } finally {
            setSyncing(false); // Stop syncing
        }
    };
    

    return (
        <div>
            <div className="iconEdit" onClick={handleShow}>
            <img className="sync-icon" src="/images/images (1).png" alt="Sync" style={{ height: '15px' }} />
                <span style={{ color: 'green' }}>{t('Sync')}</span>


            </div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title className="pageTitle">{t('Sync')}</Modal.Title>
                </Modal.Header>

                <Modal.Body className="addUserWrapper">
                    {error && <div className="alert alert-danger">{error}</div>}
                    {/* Add any additional content you want to display inside the modal */}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {t('Close')}
                    </Button>

                    <Button variant="primary" onClick={handleSync} disabled={syncing}>
                        {syncing ? t('Syncing...') : t('Syncinitiated')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Sync;
